import React, { ReactElement, useContext } from 'react'
import styled from 'styled-components'

import { graphql, useStaticQuery } from 'gatsby'
import dayjs from 'dayjs'
import { Article } from '~src/types/article'
import LanguageContext from '~components/homepage/context/language-context'
import { findImages } from '~components/homepage/utils'
import { ResponsiveImage } from '~components/homepage/styled/shared'
import { ImagesQueryData } from '~src/types/graphql-types'
import {
  ArticleDate,
  ArticleDescription,
  ArticleTitle,
  Divider,
} from './styled/shared'

const PreviewArticleContainer = styled.div`
  display: grid;
  margin-bottom: 20px;
  margin-top: 70px;
  gap: 20px;
  max-width: 325px;
`

const ArticleContentWrapper = styled.div`
  padding: 0px 20px;
  height: 190px;
  display: grid;
  grid-template-rows: 35px 1fr 85px;
  gap: 11px;
  overflow: hidden;
`

interface Props {
  article: Article
}

const PreviewArticle: React.FC<Props> = ({ article }): ReactElement => {
  const { lang } = useContext(LanguageContext)

  const currentArticle = lang === 'EN' && article.en ? article.en : article

  const data = useStaticQuery<ImagesQueryData>(
    graphql`
      query {
        allFile(filter: { sourceInstanceName: { eq: "images" } }) {
          edges {
            node {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  originalName
                  ...GatsbyImageSharpFluid
                }
              }
              name
            }
          }
        }
      }
    `
  )

  const sliderImages = findImages(data, [currentArticle.mainPicture.src])

  return (
    <div>
      <PreviewArticleContainer>
        <a href={`/article?id=${article.id}`}>
          <ResponsiveImage
            src={sliderImages[0]?.node.childImageSharp.fluid.src}
            height="217px"
            width="100%"
          />

          <ArticleContentWrapper>
            <ArticleDate>
              {dayjs(currentArticle.date).format('DD.MM.YYYY')}
            </ArticleDate>
            <ArticleTitle>{currentArticle.title}</ArticleTitle>
            <ArticleDescription>
              {[currentArticle.content?.[0], currentArticle.content?.[1]]
                .filter(item => item && item.type === 'p')
                .map(item => (item as any).content)
                .join(' ')
                .substring(0, 150)}
              ...
            </ArticleDescription>
          </ArticleContentWrapper>
        </a>
      </PreviewArticleContainer>
      <Divider />
    </div>
  )
}

export default PreviewArticle
